import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TemrVisitChiefComplaintService {
  temrVisitChiefComplaint: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'temr_visit_chief_complaint/list/?';
  private AddRecord = webapi + 'temr_visit_chief_complaint/create';
    private AddNewRecord = webapi + 'temr_visit_chief_complaint/createNew';                        // Added by Neha
    private EditRecord = webapi + 'temr_visit_chief_complaint/update';
  private GetRecord = webapi + 'temr_visit_chief_complaint/byid/';
  private DeleteRecord = webapi + 'temr_visit_chief_complaint/delete/';
  private ListByVisitId = webapi + 'temr_visit_chief_complaint/listbyvisitid/';
  private ListBytimelineId = webapi + 'temr_visit_chief_complaint/listbytimelineid/';
  private GetcomplaintdetailsByPatientId = webapi + 'temr_visit_chief_complaint/getcomplaintdetailsByPatientId/';
  private GetAllRecordByTimelineList = webapi + 'temr_visit_chief_complaint/getAllRecordByTimelineList';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordServiceByVisitId(id: any) {
    return this.http.get(this.ListByVisitId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordServiceByTimelineId(id: any) {
    return this.http.get(this.ListBytimelineId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getComplaintdetailsByPatientId(patientId: any, startdate: any, enddate: any, page: any, size: any) {
    return this.http.get(this.GetcomplaintdetailsByPatientId + patientId + '/' + startdate + '/' + enddate + '/' + page + '/' + size)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordByTimelineList(model: any) {
    return this.http.post(this.GetAllRecordByTimelineList, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
    addNewRecordService(model: any) {                                  //Added by Neha-
        return this.http.post(this.AddNewRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/temr-visit-chief-complaint/temr-visit-chief-complaint.service.ts